import request from "@/utils/request";
import { SERVERPATH } from "@/config";

// 角色授权时显示的菜单列表
export function SystemGetAuthMenuList(data) {
  return request({
    url: `${SERVERPATH}/System/getAuthMenuList`,
    method: "post",
    data
  });
}

// 仪表盘统计（今日 / 本月）
export function SystemDashboardStats() {
  return request({
    url: `/admin/System/dashboardStats`,
    method: "get"
  });
}

// 订单趋势（近 7 / 30 天）
export function SystemOrderTrend(params) {
  return request({
    url: `/admin/System/orderTrend`,
    method: "get",
    params
  });
}

// 获取菜单列表
export function SystemMenuList(data) {
  return request({
    url: `${SERVERPATH}/System/menuList`,
    method: "post",
    data
  });
}

export function SystemMenuInfo(params) {
  return request({
    url: `${SERVERPATH}/System/menuInfo`,
    method: "get",
    params
  });
}

export function SystemMenuAdd(data) {
  return request({
    url: `${SERVERPATH}/System/menuAdd`,
    method: "post",
    data
  });
}

export function SystemMenuEdit(data) {
  return request({
    url: `${SERVERPATH}/System/menuEdit`,
    method: "post",
    data
  });
}

export function SystemMenuDel(data) {
  return request({
    url: `${SERVERPATH}/System/menuDel`,
    method: "post",
    data
  });
}

// 用户角色列表
export function SystemRoleList(data) {
  return request({
    url: `${SERVERPATH}/System/roleList`,
    method: "post",
    data
  });
}

// 用户角色详情
export function SystemRoleInfo(data) {
  return request({
    url: `${SERVERPATH}/System/roleInfo`,
    method: "post",
    data
  });
}

// 用户角色新增
export function SystemRoleAdd(data) {
  return request({
    url: `${SERVERPATH}/System/roleAdd`,
    method: "post",
    data
  });
}

// 用户角色编辑
export function SystemRoleEdit(data) {
  return request({
    url: `${SERVERPATH}/System/roleEdit`,
    method: "post",
    data
  });
}

// 用户角色删除
export function SystemRoleDel(data) {
  return request({
    url: `${SERVERPATH}/System/roleDel`,
    method: "post",
    data
  });
}

// 用户列表
export function SystemAdminList(data) {
  return request({
    url: `${SERVERPATH}/System/adminList`,
    method: "post",
    data
  });
}

// 用户详情
export function SystemAdminInfo(data) {
  return request({
    url: `${SERVERPATH}/System/adminInfo`,
    method: "post",
    data
  });
}

// 用户新增
export function SystemAdminAdd(data) {
  return request({
    url: `${SERVERPATH}/System/adminAdd`,
    method: "post",
    data
  });
}

// 用户编辑
export function SystemAdminEdit(data) {
  return request({
    url: `${SERVERPATH}/System/adminEdit`,
    method: "post",
    data
  });
}

// 用户删除
export function SystemAdminDel(data) {
  return request({
    url: `${SERVERPATH}/System/adminDel`,
    method: "post",
    data
  });
}

// 角色授权
export function SystemAuthMenu(data) {
  return request({
    url: `${SERVERPATH}/System/authMenu`,
    method: "post",
    data
  });
}

// 运费列表
export function SystemPostageList(data) {
  return request({
    url: `${SERVERPATH}/Marketing/postageList`,
    method: "post",
    data
  });
}

// 运费详情
export function SystemPostageInfo(data) {
  return request({
    url: `${SERVERPATH}/Marketing/postageInfo`,
    method: "post",
    data
  });
}

// 运费新增
export function SystemPostageAdd(data) {
  return request({
    url: `${SERVERPATH}/Marketing/postageAdd`,
    method: "post",
    data
  });
}

// 运费编辑
export function SystemPostageEdit(data) {
  return request({
    url: `${SERVERPATH}/Marketing/postageEdit`,
    method: "post",
    data
  });
}

// 运费删除
export function SystemPostageDel(data) {
  return request({
    url: `${SERVERPATH}/Marketing/postageDel`,
    method: "post",
    data
  });
}

// 支付配置列表
export function SystemPayConfigList(data) {
  return request({
    url: `${SERVERPATH}/System/listWeChatConfig`,
    method: "get",
    data
  });
}

// 支付配置新增
export function SystemPayConfigAdd(data) {
  return request({
    url: `${SERVERPATH}/System/addWeChatConfig`,
    method: "post",
    data
  });
}

// 支付配置编辑
export function SystemPayConfigEdit(data) {
  return request({
    url: `${SERVERPATH}/System/editWeChatConfig`,
    method: "post",
    data
  });
}

// 支付配置删除  { id }
export function SystemPayConfigDel(data) {
  return request({
    url: `${SERVERPATH}/System/delWeChatConfig`,
    method: "post",
    data
  });
}

// 支付配修改状态  { id, status }
export function SystemPayConfigStatus(data) {
  return request({
    url: `${SERVERPATH}/System/startOrStopWeChatConfig`,
    method: "post",
    data
  });
}

export function SystemSysLogList(params) {
  return request({
    url: `${SERVERPATH}/System/sysLogList`,
    method: "get",
    params
  });
}

export function SystemSysLogInfo(params) {
  return request({
    url: `${SERVERPATH}/System/sysLogInfo`,
    method: "get",
    params
  });
}
